import { render, staticRenderFns } from "./odoo-sale-order-state-select.vue?vue&type=template&id=44c1f8b5&scoped=true&"
import script from "./odoo-sale-order-state-select.vue?vue&type=script&lang=js&"
export * from "./odoo-sale-order-state-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c1f8b5",
  null
  
)

export default component.exports